import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { ReactComponent as Close } from "../../icons/Close.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-flex",
    height: 34,
    color: theme.palette.text.primary,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 20,
    backgroundColor: `${theme.palette.primary.light}99`,
    padding: theme.spacing(0.5, 2),
    margin: theme.spacing(0.5),
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "17px",
    whiteSpace: "nowrap",
    alignContent: "center",
  },

  remove: {
    color: theme.palette.delete.primary,
    width: 22,
    height: 22,
    marginLeft: theme.spacing(1),
    cursor: "pointer",
  },
}));

export interface AddedLozengeProps extends BoxProps {
  text: string;
  onRemoveClick?: () => void;
  disabled?: boolean;
}

export function AddedLozenge(props: AddedLozengeProps) {
  const { className, text, onRemoveClick, disabled, ...other } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <Typography component="span" children={text} />
      {onRemoveClick && !disabled && (
        <Close className={s.remove} onClick={onRemoveClick} />
      )}
    </Box>
  );
}
